if (!customElements.get('accordion-component')) {
  class AccordionComponent extends HTMLElement {
    constructor () {
      super()
      this.body = this.querySelector('.acc-Accordion_Body')
      this.querySelector('[data-toggle-accordion]').addEventListener('click', this.toggleAccordion.bind(this))
    }

    connectedCallback () {

    }

    toggleAccordion () {
      const accordionItems = this.parentElement.querySelectorAll('accordion-component')

      if (!this.classList.contains('acc-Accordion-expand')) {
        accordionItems.forEach(accordion => {
          accordion.close()
        })
        this.open()
      } else {
        this.close()
      }
    }

    open () {
      this.classList.add('acc-Accordion-expand')
      this.body.style.maxHeight = `${this.body.scrollHeight}px`
    }

    close () {
      this.classList.remove('acc-Accordion-expand')
      this.body.style.maxHeight = '0px'
    }
  }

  customElements.define('accordion-component', AccordionComponent)
}
